import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    ViewEncapsulation,
} from "@angular/core";

@Component({
    selector: "cerrix-toggle-button",
    imports: [],
    templateUrl: "./cerrix-toggle-button.component.html",
    styleUrl: "./cerrix-toggle-button.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        "(click)": "$event.stopPropagation(); pressed.emit()",
        "[class.active]": "active()",
    },
})
export class CerrixToggleButtonComponent {
    active = input<boolean>(false);
    pressed = output<void>();
}
